var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcTimer = function SvgIcTimer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0013 3.5C5.05744 3.5 2.66797 5.88948 2.66797 8.83333C2.66797 11.7772 5.05744 14.1667 8.0013 14.1667C10.9452 14.1667 13.3346 11.7772 13.3346 8.83333C13.3346 5.88948 10.9452 3.5 8.0013 3.5ZM1.66797 8.83333C1.66797 5.33719 4.50516 2.5 8.0013 2.5C11.4974 2.5 14.3346 5.33719 14.3346 8.83333C14.3346 12.3295 11.4974 15.1667 8.0013 15.1667C4.50516 15.1667 1.66797 12.3295 1.66797 8.83333Z",
    fill: "#2BADA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.83594C8.27614 4.83594 8.5 5.0598 8.5 5.33594V8.66927C8.5 8.94541 8.27614 9.16927 8 9.16927C7.72386 9.16927 7.5 8.94541 7.5 8.66927V5.33594C7.5 5.0598 7.72386 4.83594 8 4.83594Z",
    fill: "#2BADA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.33594C5.5 1.0598 5.72386 0.835938 6 0.835938H10C10.2761 0.835938 10.5 1.0598 10.5 1.33594C10.5 1.61208 10.2761 1.83594 10 1.83594H6C5.72386 1.83594 5.5 1.61208 5.5 1.33594Z",
    fill: "#2BADA7"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTimer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-timer.495b357a.svg";
export { ForwardRef as ReactComponent };